import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ButtonSizes, ButtonStyles } from '../../../button/button.component';
import { ZiroIcons } from '../../../shared/models/ziro-icons.enum';
import { ApplicationLogsResource } from '../../resources/application-logs-resource.resource';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';
import { GlobalPropertiesContext } from '../../../shared/contexts/global-properties.context';
import { Subscription } from 'rxjs';
import { SystemStatusContext } from '../../../shared/contexts/system-status.context';
import { State, StatusCategory } from '../../../shared/models/generated/ziroModels';
import { ToastTypes } from '../../../shared/services/abstract/toast.service.abstract';
import { ToastService } from '../../../shared/services/toast.service';

@Component({
  selector: 'ziro-admin-application-logs',
  templateUrl: './application-logs.component.html',
  styleUrls: ['../../admin-page.scss', 'application-logs.component.scss'],
  standalone: false,
})
export class ApplicationLogsComponent implements OnInit, OnDestroy {
  private applicationLogsResource = inject(ApplicationLogsResource);
  private breadcrumbsService = inject(BreadcrumbsService);
  private _globalPropertiesContext = inject(GlobalPropertiesContext);
  private _systemStatusContext = inject(SystemStatusContext);
  private _toastService = inject(ToastService);

  private _subscriptions = new Subscription();

  isProxyEnabled = false;
  isProxyHealthy = false;
  isHostedEnabled = false;
  todaysProxyLogsIsDownloading = false;
  allProxyLogsIsDownloading = false;
  todaysLogsIsDownloading = false;
  allLogsIsDownloading = false;
  buttonSizes = ButtonSizes;
  buttonStyle = ButtonStyles;
  icons = ZiroIcons;

  ngOnInit(): void {
    this.breadcrumbsService.updateBreadcrumbs([{ label: 'tkey;pages.admin.application_logs.title' }]);
    const globalSub = this._globalPropertiesContext.state$.subscribe((globalProperties) => {
      this.isHostedEnabled = globalProperties.hostedEnabled;
    });
    const systemSub = this._systemStatusContext.state$.subscribe((systemStatus) => {
      const proxyStatus = systemStatus.healthStatuses.find((status) => status.category === StatusCategory.PROXY_SERVER);
      this.isProxyEnabled = !!proxyStatus;
      this.isProxyHealthy = proxyStatus?.state === State.OK;
    });

    this._subscriptions.add(globalSub);
    this._subscriptions.add(systemSub);
  }

  ngOnDestroy(): void {
    this.breadcrumbsService.clearBreadcrumbs();
    this._subscriptions.unsubscribe();
  }

  getAllLogs(): void {
    this.allLogsIsDownloading = true;
    this.applicationLogsResource.getAllLogs().subscribe(() => {
      this.allLogsIsDownloading = false;
      this._successfulDownloadToast();
    });
  }

  getTodaysLogs(): void {
    this.todaysLogsIsDownloading = true;
    this.applicationLogsResource.getTodaysExportLogs().subscribe(() => {
      this.todaysLogsIsDownloading = false;
      this._successfulDownloadToast();
    });
  }

  getAllProxyLogs(): void {
    this.allProxyLogsIsDownloading = true;
    this.applicationLogsResource.getAllProxyLogs().subscribe(() => {
      this.allProxyLogsIsDownloading = false;
      this._successfulDownloadToast();
    });
  }

  getTodaysProxyLogs(): void {
    this.todaysProxyLogsIsDownloading = true;
    this.applicationLogsResource.getTodaysProxyLogs().subscribe(() => {
      this.todaysProxyLogsIsDownloading = false;
      this._successfulDownloadToast();
    });
  }

  private _successfulDownloadToast(): void {
    this._toastService.push(
      ToastTypes.SUCCESS,
      ZiroIcons.DOWNLOAD,
      'tkey;admin.file_downloaded.success_toast.title',
      'tkey;admin.file_downloaded.success_toast.message',
      { fileType: 'ZIP' },
    );
  }
}
